<template>
  <div class="sn-f-b-s instructions">
    <sn-navigator id="YPSMS"></sn-navigator>
    <div class="sn-f-1 sn-f-col-b-s instructions-region">
      <sn-breadcrumb :breadcrumb="[{
        title: $sn.utils.getFunctionTitle('0', perpetual.FUNCTION_ID_YPSMS)
      }]"></sn-breadcrumb>
      <div class="sn-f-s-0 sn-f-e-c sn-header-patient">
        <div class="sn-f-s-c region">
          <div class="sn-f-s-0 sn-f-s-c patient-title">
            <div>药品名称：</div>
          </div>
          <el-input v-model="dynamic" placeholder="请输入药品名称"></el-input>
        </div>
      </div>
      <div class="sn-f-1 instructions-blank">
        <div class="sn-table" v-if="handle.length > 0">
          <table>
            <thead>
              <tr>
                <th>序号</th>
                <th>名称</th>
                <th v-if="exist('specification')">规格</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr :key="item.drugId" v-for="(item, i) in handle">
                <td>{{ i + 1 }}</td>
                <td>{{ item.name || item.medicineName }}</td>
                <td v-if="exist('specification')">{{ item.specification || '' }}</td>
                <td class="sn-omit sn-pointer sn-fc-main" @click="navigateUrl('instructions', item);">查看说明书</td>
              </tr>
            </tbody>
          </table>
        </div>
        <sn-no-data v-else></sn-no-data>
      </div>
      <div class="sn-f-s-0 sn-f-e-c pagination" v-if="functionConfig.page === '1'">
        <div class="sn-f-c-c sn-pointer pagination-interaction" :class="{'pagination-actived': pageCount > 1}" @click="exchangePage('1');">上一页</div>
        <div>当前第&nbsp;&nbsp;<span class="sn-fc-main">{{ pageCount }}</span>&nbsp;&nbsp;页</div>
        <div class="sn-f-c-c sn-pointer pagination-interaction"
        :class="{'pagination-actived': isResult || !$sn.validate.empty($sn.format.group(instructions, perpetual.PAGINATION_SIZE)[pageCount])}" @click="exchangePage('2');">下一页</div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import self from '@/common/utils/global-config';
import HomepageMixin from '@/common/mixin/homepage-mixin';
import Swagger from '@/common/utils/swagger';
import * as Messages from '@/common/utils/messages';
import * as ServiceConfig from '@/common/utils/service-config';

export default {
  mixins: [HomepageMixin],
  data() {
    return {
      functionConfig: {},
      dynamic: self.$sn.utils.getHospitalSessionStorage('MedicineInstruction_Dynamic') || '',
      pageCount: 1,
      isResult: true,
      instructions: []
    };
  },
  computed: {
    handle() {
      let result = [];
      if (this.instructions.length > 0) {
        if (this.functionConfig.search === '0' && this.dynamic) {
          result = this.instructions.filter(res => res.name.indexOf(this.dynamic) > -1);
        }
        else if (this.functionConfig.page === '1') {
          result = this.$sn.format.group(this.instructions, this.perpetual.PAGINATION_SIZE)[this.pageCount - 1];
        }
        else result = this.$sn.format.clone(this.instructions);
      }
      return result;
    },
    exist() {
      return (key) => {
        let verify = false;
        if (this.instructions.length > 0) {
          if (!this.$sn.validate.empty(this.instructions.find(result => !this.$sn.validate.empty(result[key])))) {
            verify = true;
          }
        }
        return verify;
      };
    }
  },
  watch: {
    dynamic: function(val) {
      if (val) {
        this.$sn.utils.setHospitalSessionStorage('MedicineInstruction_Dynamic', val);
        if (this.functionConfig.search === '1') {
          this.pageCount = 1;
          this.isResult = true;
          this.instructions = [];
          this.obtain();
        }
      }
      else {
        if (this.$sn.utils.getHospitalSessionStorage('MedicineInstruction_Dynamic')) {
          this.$sn.utils.removeHospitalSessionStorage('MedicineInstruction_Dynamic');
        }
      }
    },
    pageCount: function(n, o) {
      if ((n >= o || this.$sn.validate.empty(o)) && this.$sn.validate.empty(this.$sn.format.group(this.instructions, this.perpetual.PAGINATION_SIZE)[n])) {
        this.obtain();
      }
    }
  },
  created: function() {
    document.title = this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_YPSMS);
    this.$route.meta.title = this.$sn.utils.getFunctionTitle('0', this.perpetual.FUNCTION_ID_YPSMS);
    /*
    initial[string]：是否初始调用接口
    page[string]：是否启用分页
    swagger[string]：调用列表接口类型
    search[string]：是否使用接口进行关键字搜索查询
    */
    const compare = {
      [this.perpetual.HOSPITAL_ID_SDSZL]: {
        'initial': '0',
        'page': '1',
        'swagger': '1',
        'search': '1'
      },
      [this.perpetual.HOSPITAL_ID_LCRM]: {
        'initial': '1',
        'page': '0',
        'swagger': '0',
        'search': '0'
      },
      [this.perpetual.HOSPITAL_ID_JNYZ]: {
        'initial': '1',
        'page': '0',
        'swagger': '0',
        'search': '0'
      }
    };
    this.functionConfig = compare[this.$sn.utils.getHospitalId()];
    if (this.functionConfig.initial === '1' || this.dynamic) {
      this.obtain();
    }
  },
  methods: {
    obtain() {
      if (this.functionConfig.swagger === '0') {
        const code = {
          [this.perpetual.HOSPITAL_ID_LCRM]: 'e81c3a03-f87d-4fe7-b1e3-5c7b2bbce9b6',
          [this.perpetual.HOSPITAL_ID_JNYZ]: '12ac9716-1e8e-4f42-bcb7-fb4898c112b3'
        };
        this.$sn.assembly.loading(true);
        this.$sn.utils.ordinaryRequest({
          url: this.$sn.format.caption(Swagger.ordinaryTransmitLogin, [this.$sn.utils.getHospitalId(), code[this.$sn.utils.getHospitalId()]]),
          method: 'POST',
          header: true,
          data: this.$sn.utils.variableEncryption(this.$sn.format.xml({
            PharmacyId: '0281'
          }, true))
        }, ServiceConfig.ordinaryTransmitLoginComplete).then(result => {
          this.$sn.assembly.loading(false);
          if (result) {
            if (result.code === 0) {
              if (result.data) {
                if (result.data.ResultCode === '0') {
                  if (result.data.Data && result.data.Data.length > 0) {
                    this.instructions = result.data.Data.filter(res => res.drugType === '0');
                  }
                }
                else {
                  this.$sn.assembly.modal({
                    caption: result.data.ResultMsg,
                    isCancel: false
                  });
                }
              }
            }
            else {
              this.$sn.assembly.modal({
                caption: result.msg,
                isCancel: false
              });
            }
          }
          else {
            this.$sn.assembly.modal({
              caption: Messages.C001,
              isCancel: false
            });
          }
        });
      }
      else if (this.functionConfig.swagger === '1') {
        if (this.$sn.validate.empty(this.dynamic)) return false;
        if (this.functionConfig.page === '1' && !this.isResult) return false;
        const params = {
          url: this.$sn.format.caption(Swagger.getMedicinePriceTable, [this.$sn.utils.getHospitalId()]),
          query: {
            input: this.dynamic,
            type: '1'
          }
        };
        if (this.functionConfig.page === '1') {
          this.isResult = false;
          this.$set(params.query, 'page', this.pageCount);
          this.$set(params.query, 'size', this.perpetual.PAGINATION_SIZE);
        }
        this.$sn.assembly.loading(true);
        this.$sn.utils.ordinaryRequest(params).then(result => {
          this.$sn.assembly.loading(false);
          if (result) {
            if (result.code === 0) {
              if (result.data) {
                if (result.data.ResultCode === '0') {
                  if (result.data.Data && result.data.Data.length > 0) {
                    if (this.functionConfig.page === '1') {
                      this.isResult = result.data.Data.length === this.perpetual.PAGINATION_SIZE;
                      if (this.pageCount === 1) {
                        this.instructions = result.data.Data;
                      }
                      else this.instructions = this.instructions.concat(result.data.Data);
                    }
                    else this.instructions = result.data.Data;
                  }
                }
                else {
                  this.$sn.assembly.modal({
                    caption: result.data.ResultMsg,
                    isCancel: false
                  });
                }
              }
            }
            else {
              this.$sn.assembly.modal({
                caption: result.msg,
                isCancel: false
              });
            }
          }
          else {
            this.$sn.assembly.modal({
              caption: Messages.C001,
              isCancel: false
            });
          }
        });
      }
    },
    // 1：上一页；2：下一页
    exchangePage(type) {
      if (type === '1') {
        if (this.pageCount > 1) this.pageCount--;
      }
      else if (type === '2') {
        if (this.isResult || !this.$sn.validate.empty(this.$sn.format.group(this.instructions, this.perpetual.PAGINATION_SIZE)[this.pageCount])) this.pageCount++;
      }
    },
    navigateUrl(url, item, params, type = 'push') {
      if (this.$sn.validate.empty(url)) return false;
      if (url === 'instructions') {
        const code = {
          [this.perpetual.HOSPITAL_ID_LCRM]: 'bf2727e0-7907-48d5-b72f-3c84c9bd47d3',
          [this.perpetual.HOSPITAL_ID_JNYZ]: '823b05ee-6cc3-492f-b427-f75ed222622a',
          [this.perpetual.HOSPITAL_ID_SDSZL]: '3963561e-4f0d-f4fd-fccc-b7e12057d87f'
        };
        this.$sn.assembly.loading(true);
        this.$sn.utils.ordinaryRequest({
          url: this.$sn.format.caption(Swagger.ordinaryTransmitLogin, [this.$sn.utils.getHospitalId(), code[this.$sn.utils.getHospitalId()]]),
          method: 'POST',
          header: true,
          data: this.$sn.utils.variableEncryption(this.$sn.format.xml({
            Data: JSON.stringify({
              drugId: item.drugId || item.code,
              drugName: item.name || item.medicineName
            }),
            PlatformId: this.$sn.utils.getPlatformType(),
            PlatformUserId: this.$sn.utils.getOpenId(),
            Type: '9'
          }))
        }, ServiceConfig.ordinaryTransmitLoginComplete).then(result => {
          this.$sn.assembly.loading(false);
          if (result) {
            if (result.code === 0) {
              if (result.data) {
                if (result.data.ResultCode === '0') {
                  if (result.data.Data && result.data.Data.url) {
                    this.navigateUrl(result.data.Data.url);
                  }
                  else {
                    this.$sn.assembly.modal({
                      caption: Messages.C002,
                      isCancel: false
                    });
                  }
                }
                else {
                  this.$sn.assembly.modal({
                    caption: result.data.ResultMsg,
                    isCancel: false
                  });
                }
              }
              else {
                this.$sn.assembly.modal({
                  caption: Messages.C002,
                  isCancel: false
                });
              }
            }
            else {
              this.$sn.assembly.modal({
                caption: result.msg,
                isCancel: false
              });
            }
          }
          else {
            this.$sn.assembly.modal({
              caption: Messages.C001,
              isCancel: false
            });
          }
        });
      }
      else {
        this.homepage_mixin_navigateUrl(url, item, params, type);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.instructions {
  overflow: hidden;
  width: 100%;
  height: 100%;

  &-region {
    overflow: hidden;
    height: 100%;

    .sn-header-patient {
      width: calc(100% - 40px);
      margin: 0 20px 20px;
    }

    .instructions-blank {
      overflow: hidden;
      width: 100%;
      padding: 0 20px 20px;
    }

    .pagination {
      @include fs(16);

      width: 100%;
      height: 40px;
      margin: 20px 0 40px;

      &-interaction {
        height: 40px;
        color: $text6;
        border: 1px solid $border1;
        border-radius: 5px;
        padding: 0 20px;
        margin: 0 10px;

        &:last-child {
          margin-right: 20px;
        }
      }

      &-actived {
        color: $text1;

        &:hover {
          background-color: $main4;
          color: $main3;
          border: 1px solid $main3;
        }
      }
    }
  }
}
</style>
